var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-block"},[_c('video',{staticClass:"video-block__video",attrs:{"id":"video","poster":_vm.poster},domProps:{"muted":_vm.muted},on:{"click":function($event){_vm.videoAction('toggle')}}},[_c('source',{attrs:{"src":_vm.source,"type":"video/mp4"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f80f7da","hasScoped":false,"transformToRequire":{"video":"src","source":["src","srcset"],"vector":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/video/video.block.vue
// module id = giLd
// module chunks = 1